module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.items), function(item) {
    return _c('swiper-slide', {
      key: item
    }, [_c('p', {
      staticClass: "desc pFirst"
    }, [_vm._v("智能公安系统综合解决方案提供商")]), _vm._v(" "), _c('p', {
      staticClass: "desc"
    }, [_vm._v("深厚的行业经验，多年的技术积累")]), _vm._v(" "), _c('p', {
      staticClass: "subDesc"
    }, [_vm._v("致力于提供专业、安全、可信的产品和服务")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev"
  })], 2), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "friend"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("合作伙伴")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("加入合作伙伴")]), _vm._v(" "), _c('div', {
    staticClass: "imglist"
  }, [_c('div', {
    staticClass: "nowDiv animated",
    on: {
      "mouseover": _vm.big,
      "mouseout": _vm.nowDiv
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/1.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nowDiv animated",
    on: {
      "mouseover": _vm.big,
      "mouseout": _vm.nowDiv
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/2.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nowDiv animated",
    on: {
      "mouseover": _vm.big,
      "mouseout": _vm.nowDiv
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/3.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nowDiv animated",
    on: {
      "mouseover": _vm.big,
      "mouseout": _vm.nowDiv
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/4.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nowDiv animated",
    on: {
      "mouseover": _vm.big,
      "mouseout": _vm.nowDiv
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/5.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "imglist"
  }, [_c('div', {
    staticClass: "nowDiv animated",
    on: {
      "mouseover": _vm.big,
      "mouseout": _vm.nowDiv
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/6.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nowDiv animated",
    on: {
      "mouseover": _vm.big,
      "mouseout": _vm.nowDiv
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/7.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nowDiv animated",
    on: {
      "mouseover": _vm.big,
      "mouseout": _vm.nowDiv
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/8.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nowDiv animated",
    on: {
      "mouseover": _vm.big,
      "mouseout": _vm.nowDiv
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/9.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nowDiv animated",
    on: {
      "mouseover": _vm.big,
      "mouseout": _vm.nowDiv
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/10.png")
    }
  })])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('img', {
    staticClass: "toTop",
    attrs: {
      "src": require("../../assets/img/toTop.png")
    },
    on: {
      "click": _vm.toTop
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case1"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("安全、可靠的服务能力")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("具有完备的行业资质，符合ISO9001质量管理体系，确保为客户提供的专业、安全、可靠、可信的产品和服务")]), _vm._v(" "), _c('img', {
    staticClass: "caseImg animated",
    attrs: {
      "src": require("../../assets/img/case1.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case2 clearfix"
  }, [_c('div', {
    staticClass: "caseImg2"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/pic1.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caseWord animated"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("资深、专业的技术团队")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("近10年的行业经验，专注于交通信息化建设的项目的专业技术人才，")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("满足最苛刻的设计要求")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case3 clearfix"
  }, [_c('div', {
    staticClass: "caseWord3 animated"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("各行各业的客户成功案例")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("包括政府、企业、公共部门等行业，协助合作伙伴多次获得各种奖项")])]), _vm._v(" "), _c('div', {
    staticClass: "caseImg3"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/pic2.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product clearfix"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("产品案例")]), _vm._v(" "), _c('div', {
    staticClass: "productList"
  }, [_c('div', {
    staticClass: "pro hasMarginRight"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/case01.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "proTitle"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("智能交通集成指挥平台系统")])]), _vm._v(" "), _c('p', {
    staticClass: "subProTitle"
  }, [_vm._v("交通管控大数据分析研判系统构建了一个支持横向扩展，具有分布、并行、高效特点的交通信息大数据处理平台，能为城市的交通相关信息处理")])]), _vm._v(" "), _c('div', {
    staticClass: "pro hasMarginLeft"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/case2.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "proTitle"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("环保车辆便民信息服务应用")])]), _vm._v(" "), _c('p', {
    staticClass: "subProTitle"
  }, [_vm._v("出行易是为公众出行提供实时、准确、便捷、个性化的交通信息服务。可随时、随地、全方位地掌握城市的交通路况")])])]), _vm._v(" "), _c('div', {
    staticClass: "productList"
  }, [_c('div', {
    staticClass: "pro hasMarginRight"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/case3.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "proTitle"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("平安城市建设系统，4G围栏系统")])]), _vm._v(" "), _c('p', {
    staticClass: "subProTitle"
  }, [_vm._v("\"智慧城市\"是一个系统，它将城市中的人、交通、能源、商业、通信等各方面的物理基础设施、信息基础设施、社会基础设施和商业基础设施")])]), _vm._v(" "), _c('div', {
    staticClass: "pro hasMarginLeft"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/case4.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "proTitle"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("手机信号屏蔽管理系统")])]), _vm._v(" "), _c('p', {
    staticClass: "subProTitle"
  }, [_vm._v("基于主动干扰和主动屏蔽为一体的全频段手机信号屏蔽系统。通过专用的手机信号干扰系统和基于纳米材料的全频段手机信号屏蔽袋的结合，能")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/logo.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("联系电话"), _c('span', [_vm._v("020-28163056")])]), _vm._v(" "), _c('p', [_vm._v("联系邮箱"), _c('span', [_vm._v("support@dunheinfo.com")])]), _vm._v(" "), _c('p', [_vm._v("联系地址"), _c('span', [_vm._v("广州高新技术产业开发区科学大道112号绿地中央广场A1栋1804房")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "allRight"
  }, [_c('p', [_vm._v("广州敦和信息技术有限公司")]), _vm._v(" "), _c('p', [_vm._v("Copyright ©2016 dunheinfo.com, All Rights Reserved.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "http://www.miibeian.gov.cn/"
    }
  }, [_vm._v("粤ICP备16099263号-1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-273f794a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/Index.vue
// module id = 43
// module chunks = 0